import './index.scss';
import React from 'react';
import { createRoot } from 'react-dom/client'; // 변경된 임포트
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, persistor } from './reduxToolkit/store'; // Redux Persist 설정 추가
import { PersistGate } from 'redux-persist/integration/react'; // PersistGate 추가


const root = createRoot(document.getElementById('root')); // createRoot 사용
root.render(
  <HelmetProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <App />
        </Router>
      </PersistGate>
    </Provider>
  </HelmetProvider>
);
